import firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

// Configuração do projeto FE
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: "G-MNS3JRHF0C"
};

// Inicializar Firebase com projeto FE
const firebaseApp = firebase.initializeApp(firebaseConfig);
// Export other Firebase services you need
export const db = firebaseApp;
export const storage = firebase.storage();
export const auth = firebase.auth();
export const FieldValue = firebase.firestore.FieldValue;

let messaging = null;

try {
  messaging = firebase.messaging();
} catch (err) {
  // Messaging might not be supported in all environments (SSR, older browsers)
  console.warn('Firebase messaging is not supported in this environment:', err);
}



// VAPID key for getting tokens
export const VAPID_KEY = "BJqDgw5rSJ8qmnvU8_oM6c1UfRBCzi3QF62AAmlNgXyG4OxLQJVKEyAIOlXSwP9wKFqQRHzVL86fky1dvvIi4ic";

// Helper function to get FCM token with VAPID key
export const getFCMToken = async () => {
  try {
    if (!messaging) {
      throw new Error('Messaging not available');
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      throw new Error('Notification permission denied');
    }

    // Get FCM token with VAPID key
    const token = await messaging.getToken({ 
      vapidKey: VAPID_KEY 
    });
    
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    throw error;
  }
};

export { firebase, messaging, firebaseApp };
/* import firebase from 'firebase/app';
import 'firebase/messaging';

// Configuração do projeto FE
const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: "G-MNS3JRHF0C"
};

// Inicializar Firebase com projeto FE
firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

// Use a CHAVE PÚBLICA VAPID do projeto FE
messaging.usePublicVapidKey("BJqDgw5rSJ8qmnvU8_oM6c1UfRBCzi3QF62AAmlNgXyG4OxLQJVKEyAIOlXSwP9wKFqQRHzVL86fky1dvvIi4ic");

export { messaging, firebase };





import firebase from "firebase";
import "firebase/firestore";
import "firebase/storage"
import "firebase/auth";
import 'firebase/messaging';


let firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: "G-MNS3JRHF0C"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

let messaging = null;

try {
  messaging = firebase.messaging();
} catch (err) {
  // Messaging might not be supported in all environments (SSR, older browsers)
  console.warn('Firebase messaging is not supported in this environment:', err);
}

export { firebase, messaging };
export const FieldValue = firebase.firestore.FieldValue
export const db = firebaseApp;

 */